<template>
  <div class="d-print-none backgroundWhite">
    <v-navigation-drawer
      :mini-variant="expand_nav"
      :expand-on-hover="expand_nav"
      v-if="$auth.isAuthenticated"
      v-model="$store.state.show_nav_bar"
      app
    >
      <v-list dense>
        <v-list-item-group color="primary">
          <v-list-item to="/">
            <v-list-item-action class="px-1">
              <v-img class="image-border" contain :src="`/assets/images/${app_icon}`" height="35px" />
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            v-for="(tab, index) in tabs"
            :key="`${tab.value}_${index}`"
            class="nav-items"
            @click="open_section(tab.label)"
            :to="tab.route"
          >
            <v-list-item-action>
              <v-icon>{{ tab.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ tab.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <v-list dense bottom>
          <v-list-item-group color="primary">
            <v-list-item class="profile_con" @click="open_section('Profile')" to="/profile">
              <v-list-item-action>
                <v-avatar class="mx-1" tile size="2em">
                  <img :src="$auth.user.picture" />
                </v-avatar>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primaryGrey--text">{{ $auth.user.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: { tabs: Array, app_icon: String },
  data: () => ({
    page_config: null,
    network_error: false,
  }),
  mounted() {
    this.page_config = this.$config;
  },
  methods: {
    open_section(s) {
      this.$store.commit("clear_search");
      this.$store.commit("update_page_title", s);
    },
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    expand_nav() {
      const SCREEN_WIDTH_BREAKPOINT = 1600; // Nav bar - always expanded if greater than breakpoint
      let screen_width = this.$vuetify.breakpoint.width;
      return screen_width < SCREEN_WIDTH_BREAKPOINT;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-border {
  // border: solid 1px var(--v-borderLight-base);
  border-radius: 5px;
}
</style>
